import router from './router'
import store from './store/index'
import NProgress from 'nprogress' // Progress 进度条
// import 'nprogress/nprogress.css'// Progress 进度条样式
import { Notification } from 'element-ui'
import { isLoggedIn, getPermission } from './api/common/auth' // 验权
import { tryToInt } from './configs/functions'

import sysLocalStorage from './store/localStorage'
import { getDataSource } from '@/api/common/select'

const whiteList = ['/login', '/videoplaywin', '/404'] // 不重定向白名单
const accessList = ['/dashboard', '/myprofile'] // 不校验权限白名单

router.beforeEach((to: any, from: any, next: any) => {
  document.title = window.baseConfig.SiteName
  if (to && to.name) {
    document.title += '-' + to.name
    if (to.name == '404') {
      next('/404')
    }
  }
  NProgress.start()
  if (isLoggedIn()) {
    checkCommonData()
    //这里转为小写用来判断，下面传到后台验证的时候，还是要用回大小写格式
    const toPath = to.path.toLowerCase()
    if (toPath === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    }
    else if (toPath !== '/' && accessList.indexOf(toPath) === -1 && whiteList.indexOf(toPath) === -1) {
      const user = store.getters['user/userInfo']
      if (from.path == '/myprofile' && toPath.toLowerCase() === `/user/edit/${user.Id}`) {
        //跳过验证，用户修改自己的信息
        next()
      }
      else {
        /*
        这里做权限验证，把to.path传到后台，获取对应页面权限。
        path="/XXX",列表页面，需要有View权限
        path="/XXX/New"，新增页面，需要有Add权限
        path="/XXX/Edit/:id"，编辑页面，需要有Edit权限
        另外还有Audit,审核页面，需要有Approve权限
        */
        getPermission(to.path).then((response: { data: any }) => {
          const data: any = response.data
          if (data.IsAllowed) {
            const pagePermission: any = {
              pagePath: to.path,
              permission: {
                HasView: data.HasView,
                HasAdd: data.HasAdd,
                HasApprove: data.HasApprove,
                HasDel: data.HasDel,
                HasEdit: data.HasEdit,
                HasBack: data.HasBack
              }
            }
            store.dispatch('pagePermission/SetPagePermission', pagePermission)
            //获取单个页面的数据源
            setPageSource(to.path, next)
          } else {
            Notification.warning({
              title: '警告',
              message: '您没有该页面的访问权限'
            });
            // next({ path: '/' })
            NProgress.done()
          }
        })
      }
    }
    else {
      next()
    }
  }
  else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    }
    else {
      next('/login')
      NProgress.done()
    }
  }
})

//检查通用数据源，解决页面刷新时vuex数据丢失问题
const checkCommonData = () => {
  //dispatch：含有异步操作，数据提交至 actions ，可用于向后台提交数据
  store.dispatch('dataSource/SetCommonData')
  //commit：同步操作，数据提交至 mutations ，可用于登录成功后读取用户信息写到缓存里
  // store.commit('dataSource/SetCommonData', 1)
}

//获取单个页面的数据源
const setPageSource = (path: any, next: any) => {
  var storageName = 'PageSource' + path.replace((new RegExp('/', 'g')), '_')
  var storageData = sysLocalStorage.getItem(storageName)
  if (storageData) {
    store.dispatch('dataSource/SetPageData', JSON.parse(storageData))
    next()
    NProgress.done()
  }
  else {
    getDataSource(path).then((response: { data: any }) => {
      var data = response.data
      if (data) {
        sysLocalStorage.setItem(storageName, JSON.stringify(data))
        store.dispatch('dataSource/SetPageData', data)
      }
      next()
      NProgress.done()
    }).catch((error: any) => {
      sysLocalStorage.removeItem(storageName)
      next()
      NProgress.done()
    })
  }
}
router.afterEach(() => {
  NProgress.done() // 结束Progress
})
router.onError((error: any) => {
  console.log('router.onError', error)
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.currentRoute.fullPath
  try {
    if (isChunkLoadFailed) {
      let LoadingChunk: number = tryToInt(window.sessionStorage.getItem('LoadingChunk'))
      if (LoadingChunk) {
        window.sessionStorage.setItem('LoadingChunk', (LoadingChunk + 1).toString())
      } else {
        window.sessionStorage.setItem('LoadingChunk', '1')
      }
      if (LoadingChunk > 1) {
        // 防止 死循环
        return false
      }
      router.replace(targetPath)
      window.sessionStorage.setItem('LoadingChunkPath', targetPath)
    }
  } catch (e) {
    console.log(e)
  }
})

router.onReady((vm: any) => {
  try {
    let LoadingChunkPath = window.sessionStorage.getItem('LoadingChunkPath')
    const path = vm.path
    if (LoadingChunkPath) {
      if (path !== LoadingChunkPath && path !== '/') {
        window.sessionStorage.setItem('LoadingChunkPath', vm.path)
        router.replace(vm.path)
      } else {
        router.replace(LoadingChunkPath)
      }
    }
  } catch (e) {
    console.log(e)
  }
})

